export const MENU_CATEGORIES = {
  new: { id: 'new', urlName: 'new' },
  trans: { id: 'trans', byLanguage: true, urlName: 'translated' },
  rele: { id: 'rele', urlName: 'relevant' },
  comp: { id: 'comp', urlName: 'compendia' },
  econ: { id: 'econ', urlName: 'economy' }
}

export const SUBCATEGORIES_MAP = {
  mdvc: {
    id: 'mdvc',
    name: 'Medication Delivery Vascular Care',
    title: 'Vascular Care:',
    subtitle: 'Posiflush - Chloraprep - Statlock'
  },
  vad: {
    id: 'vad',
    name: 'Vascular Access Devices',
    title: 'Central Line Products:',
    subtitle: 'PICC - PIVC'
  },
  iva: {
    id: 'iva',
    name: 'Infusion Vascular Access',
    title: 'Conectores:',
    subtitle: 'Q-syte - MaxZero - Smartsite'
  },
  hypo: {
    id: 'hypo',
    name: 'Hypo - Anestesia',
    hideId: true
  },
  onco: {
    id: 'onco',
    name: 'Oncología',
    hideId: true
  }
}

export const LANGUAGES_MAP = {
  es: {
    id: 'es'
  },
  pt: {
    id: 'pt'
  }
}

export const CATEGORIES_OBJ = {
  new: 'new',
  translated: 'trans',
  relevant: 'rele',
  compendia: 'comp',
  economy: 'econ'
}
